import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_attribute_value",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row align-items-end g-9" }
const _hoisted_9 = { class: "col-md-9 fv-row" }
const _hoisted_10 = { class: "col-md-3 fv-row " }
const _hoisted_11 = {
  key: 1,
  class: "demo-color-block el-form-item__content"
}
const _hoisted_12 = { class: "modal-footer flex-center" }
const _hoisted_13 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_14 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.attributeValueData,
          ref: "addAttributeValueForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(_ctx.$t('message.ADD_ATTRIBUTE_VALUE')), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "name",
                      label: `${_ctx.$t('message.NAME')} (${_ctx.locale})`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                      requiredMsg: _ctx.$t('message.NAME_IS_REQUIRED'),
                      "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.attributeValueData.name = $event)),
                      target: "name",
                      required: true,
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue(_ctx.attributeValueData.name))),
                      value: _ctx.attributeValueData.name
                    }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Select, {
                      name: "locale",
                      target: "locale",
                      callEmit: true,
                      required: false,
                      label: false,
                      locale: _ctx.locale,
                      "onUpdate:locale": _cache[3] || (_cache[3] = ($event: any) => (_ctx.locale = $event)),
                      selectData: _ctx.locales,
                      value: _ctx.locale,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLang(_ctx.locale)))
                    }, null, 8, ["locale", "selectData", "value"])
                  ])
                ])
              ]),
              _createVNode(_component_Select, {
                name: "attribute_id",
                target: "attribute_id",
                label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.ATTRIBUTE')}`,
                required: false,
                attribute_id: _ctx.attributeValueData.attribute_id,
                "onUpdate:attribute_id": _cache[5] || (_cache[5] = ($event: any) => (_ctx.attributeValueData.attribute_id = $event)),
                selectData: _ctx.attributes,
                value: _ctx.attributeValueData.attribute_id
              }, null, 8, ["label", "attribute_id", "selectData", "value"]),
              _createVNode(_component_Select, {
                name: "variant_type",
                target: "variant_type",
                label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.VARIANT_TYPE')}`,
                requiredMsg: `${_ctx.$t('message.VARIANT_TYPE')} ${_ctx.$t('message.IS_REQUIRED')}`,
                required: true,
                variant_type: _ctx.attributeValueData.variant_type,
                "onUpdate:variant_type": _cache[6] || (_cache[6] = ($event: any) => (_ctx.attributeValueData.variant_type = $event)),
                selectData: _ctx.variant_types,
                value: _ctx.attributeValueData.variant_type,
                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeType()))
              }, null, 8, ["label", "requiredMsg", "variant_type", "selectData", "value"]),
              (_ctx.attributeValueData.variant_type == 'Size' || _ctx.attributeValueData.variant_type == 'Weight')
                ? (_openBlock(), _createBlock(_component_Input, {
                    key: 0,
                    type: "text",
                    name: "variant_value",
                    label: _ctx.$t('message.VARIANT_VALUE'),
                    placeholder: _ctx.$t('message.ENTER_VARIANT_VALUE'),
                    requiredMsg: `${_ctx.$t('message.VARIANT_VALUE')} ${_ctx.$t('message.IS_REQUIRED')}`,
                    variant_value: _ctx.attributeValueData.variant_value,
                    "onUpdate:variant_value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.attributeValueData.variant_value = $event)),
                    target: "variant_value",
                    required: true,
                    value: _ctx.attributeValueData.variant_value
                  }, null, 8, ["label", "placeholder", "requiredMsg", "variant_value", "value"]))
                : _createCommentVNode("", true),
              (_ctx.attributeValueData.variant_type == 'Color')
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode(_component_el_color_picker, {
                      modelValue: _ctx.attributeValueData.variant_value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.attributeValueData.variant_value = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("button", _hoisted_13, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}